// External
import { useMutation, useQueryClient } from '@tanstack/react-query';
// Shared components
import { toast } from '@/hooks/use-toast';
import { toastWithLink } from '@/components/ui/toast';
// Hooks
import { useTranslation } from '../useTranslation';
// API
import { activateResaleItem, deactivateResaleItem, resaleItemsQueryKeys } from '@api/resaleItems';

export function useUpdateResaleItemStatus() {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: async ({ id, active }: { id: number; active: boolean }) => {
      return active ? activateResaleItem(id) : deactivateResaleItem(id);
    },
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: resaleItemsQueryKeys.lists() });
      queryClient.invalidateQueries({ queryKey: resaleItemsQueryKeys.detail(variables.id) });

      toastWithLink({
        name: data.resale_item.name,
        href: `/resale_items/${data.resale_item.id}/edit`,
        label: t(data.resale_item.active ? 'toast.activated' : 'toast.deactivated'),
      });
    },
    onError: (error) => {
      toast({
        description: error.message || t('toast.status_update_error'),
        variant: 'destructive',
      });
    },
  });
}
